import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { CkeditorPlugin } from "@ckeditor/ckeditor5-vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { createHead } from "@vueuse/head";
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { VDateInput } from "vuetify/labs/VDateInput";
import { boardUrl } from "./utilities/Api.js";

const vuetify = createVuetify({
    icons: {
        defaultSet: "mdi",
    },
    components: {
        ...components,
        VDateInput,
    },
    directives,
});

window.addEventListener("message", (event) => {
    if (event.origin != boardUrl) {
        return;
    }

    if (event.data?.type == "EDITOR_DONE") {
        window.location.reload();
    } else if (event.data?.type == "EDITOR_CLOSE") {
        // nothing happen
    }
});

const pinia = createPinia();
const head = createHead();
pinia.use(piniaPluginPersistedstate);

createApp(App)
    .use(store)
    .use(router)
    .use(head)
    .use(CkeditorPlugin)
    .use(pinia)
    .use(vuetify)
    .mount("#app");
